export default __webpack_public_path__ + "static/media/alert_icon.1d8c8484.svg";